export default "__VITE_PUBLIC_ASSET__de5d9f2b__"